import React, { useEffect, useState } from 'react';
import {
  Row,
  Col,
  Container,
  Form,
  InputGroup,
  Button,
  Card,
} from '@themesberg/react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faUserPlus,
  faRefresh,
  faHourglassStart,
  faFileInvoice,
  faBox,
  faTruckFast,
  faCircleCheck,
  faPeopleCarry,
  faArrowUp,
  faArrowDown,
  faPenNib,
  faCity,
  faBusinessTime,
  faHourglassEnd,
  faClock,
} from '@fortawesome/free-solid-svg-icons';
// import TableOnly from "../../scheme-management/Components/IndividualScheme.js/TableOnly";
import { useLocation, useNavigate } from 'react-router-dom';
import ExportButton from '../orders/components/ExportButton';
import { t } from 'i18next';
import DatePicker from '../../tripPayments/DatePicker';
import { apiCall } from '../../../middlewares/api';
import { apiCallConsts } from '../../../constants/apiCallConsts';
import { useDispatch } from 'react-redux';
import { updateSpinnerState } from '../../../actions/spinner';
import { updateToastInfo } from '../../../actions/settings';
import EditableDropDown from '../../../components/common/EditableDropdown';
import { setPageNumberInStore } from '../../../actions/tablePage';
import TableOnly from '../../scheme-management/Components/IndividualScheme/TableOnly';
import { orderAssignedColumns, orderTableColumns } from '../orders/utils';

const Order2ShippedReport = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [filterData, setFilterData] = useState({
    startDate: '',
    endDate: '',
    status: 'Ready For Pickup,Invoiced',
  });
  const [totalObj, setTotalObj] = useState([]);
  const [responseData, setResponseData] = useState({});
  const dispatch = useDispatch();
  const reportTypeArray = [];
  const fetchDate = async () => {
    try {
      dispatch(updateSpinnerState(true));
      dispatch(setPageNumberInStore({ id: 'Analytics Data', page: 1 }));
      const data = await apiCall(
        apiCallConsts?.GET_METHOD,
        `/internal/dashboard/order2shipped?status=${filterData?.status}`
      );
      console.log(data);

      setTableData(data?.obj?.totalOrders);
      setTotalObj(data?.obj?.totalCount);
      setResponseData(data);
      dispatch(updateSpinnerState(false));
    } catch (error) {
      dispatch(updateSpinnerState(false));
      dispatch(
        updateToastInfo({
          show: true,
          type: 'danger',
          title: t('Failed Getting Products data'),
          message: t(error.message),
        })
      );
    }
  };

  const handleRefresh = () => {
    try {
      fetchDate();
    } catch (error) {}
  };

  useEffect((each) => {
    try {
      fetchDate();
    } catch (error) {}
  }, []);

  const [tableData, setTableData] = useState([]);
  const [selectedCard, setSelectedCard] = useState(null);

  return (
    <div
      className="h-100 w-100"
      style={{
        minHeight: '100vh',
        padding: '16px',
        backgroundColor: '#F5F8FB',
      }}
    >
      <Container fluid className="px-3">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h2 className="h5 mb-0">Invoice to Shipped Report</h2>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              width: '17%',
            }}
          >
            <Button
              variant="white"
              onClick={() => {
                handleRefresh();
              }}
              style={{
                width: '150px',
                height: '38px',
                borderRadius: 0,
              }}
              size="sm"
            >
              <FontAwesomeIcon icon={faRefresh} />
              &nbsp;&nbsp;{t('Refresh')}
            </Button>
            <ExportButton
              className="btn-export"
              data={tableData}
              columns={[
                {
                  field: 'Order Date ',
                  key: 'orderDate',
                },
                {
                  field: 'Order Time',
                  key: 'orderTime',
                },
                { field: 'Order Number', key: 'orderNo' },
                { field: 'Item Line No', key: 'itemLineNo' },
                { field: 'CustomerId', key: 'customerId' },
                { field: 'Internal Status', key: 'status' },
                { field: 'Customer Status', key: 'orderStatus' },
                { field: 'Customer Name', key: 'customerName' },
                { field: 'Mobile Number', key: 'mobileNumber' },
                { field: 'Email', key: 'email' },
                {
                  field: 'Billing Address Line 1',
                  key: 'billingAddress1',
                },
                {
                  field: 'Billing Address Line 2',
                  key: 'billingAddress2',
                },
                { field: 'Billing City', key: 'billingCity' },
                { field: 'Billing Pincode', key: 'billingPincode' },
                { field: 'Billing State', key: 'billingState' },
                {
                  field: 'Shipping Address Line 1',
                  key: 'shippingAddress1',
                },
                {
                  field: 'Shipping Address Line 2',
                  key: 'shippingAddress2',
                },
                { field: 'Shipping City', key: 'shippingCity' },
                {
                  field: 'Shipping Pincode',
                  key: 'shippingPincode',
                },
                { field: 'Shipping State', key: 'shippingState' },
                { field: 'VAN No', key: 'vanNo' },
                { field: 'Product Title', key: 'productTitle' },
                { field: 'Category', key: 'category' },
                { field: 'Sub Category', key: 'subCategory' },
                { field: 'l1', key: 'l1' },
                { field: 'l2', key: 'l2' },
                { field: 'l3', key: 'l3' },
                { field: 'l4', key: 'l4' },
                { field: 'Brand', key: 'brand' },
                { field: 'Quantity', key: 'quantity' },
                { field: 'VSPrice', key: 'vsPrice' },
                { field: 'Price', key: 'billingAmount' },
                { field: 'MRP', key: 'mrp' },
                { field: 'Order Amount', key: 'orderAmount' },
                { field: 'Invoice No', key: 'invoiceNo' },
                { field: 'Store Name', key: 'storeCode' },
                { field: 'Region', key: 'zone' },
                { field: 'GSTIN', key: 'gstin' },
                { field: 'Ewaybill No', key: 'ewayBillNo' },
                { field: 'Approval Code', key: 'approvalCode' },
                { field: 'Card No', key: 'cardNo' },
                { field: 'Product Type', key: 'size' },
                { field: 'Transaction ID', key: 'paymentType' },
                { field: 'Payment GateWay', key: 'paymentGateway' },
                { field: 'Payment Status', key: 'paymentStatus' },
                { field: 'GST', key: 'igst' },
                {
                  field: 'Expected Delivery Date',
                  key: 'expectedDeliveryDate',
                },
                {
                  field: 'Delivered Date',
                  key: 'deliveredDate',
                },
                { field: 'awbNumber', key: 'awbNumber' },
                { field: 'Bank Name', key: 'bankName' },
                { field: 'HSN Number', key: 'hsn_number' },
              ]}
              fileName={selectedCard}
            />
          </div>
        </div>

        <div
          className="d-flex flex-wrap gap-1 mb-3"
          style={{ justifyContent: 'space-between' }}
        >
          <Card
            className={`flex-grow-1 shadow-sm border-1 cursor-pointer transition-all ${
              selectedCard === 'totalOrders' ? 'border-primary shadow-lg' : ''
            }`}
            style={{ minWidth: '225px', maxWidth: '18%', cursor: 'pointer' }}
            onClick={() => {
              const isSelected = selectedCard === 'totalOrders';
              setSelectedCard(isSelected ? '' : 'totalOrders');
              setTableData(responseData.obj?.['totalOrders']);
            }}
          >
            <Card.Body className="d-flex align-items-center justify-content-between">
              <div>
                <div className="text-muted small">Total Orders</div>
                <div className="h4 mb-0">
                  {responseData?.obj?.totalOrderCount || 0}
                </div>
              </div>
              <FontAwesomeIcon icon={faCity} className="h4 mb-0" />
            </Card.Body>
            <p className="text-dark px-3 mb-3">Total order to process</p>
          </Card>

          <Card
            className={`flex-grow-1 shadow-sm border-1 cursor-pointer transition-all ${
              selectedCard === 'sameDayOrders' ? 'border-primary shadow-lg' : ''
            }`}
            style={{ minWidth: '225px', maxWidth: '18%', cursor: 'pointer' }}
            onClick={() => {
              const isSelected = selectedCard === 'sameDayOrders';
              setSelectedCard(isSelected ? '' : 'sameDayOrders');
              setTableData(responseData.obj?.['sameDayOrders']);
            }}
          >
            <Card.Body className="d-flex align-items-center justify-content-between">
              <div>
                <div className="text-muted small">Today Order</div>
                <div className="h4 mb-0">
                  {responseData?.obj?.sameDayOrdersCount || 0}
                </div>
              </div>
              <FontAwesomeIcon icon={faClock} className=" h4 mb-0" />
            </Card.Body>
            <p className="text-danger px-3 mb-3">
              Process Before 2:30 PM Today
            </p>
          </Card>

          <Card
            className={`flex-grow-1 shadow-sm border-1 cursor-pointer transition-all ${
              selectedCard === 'processedOrders'
                ? 'border-primary shadow-lg'
                : ''
            }`}
            style={{ minWidth: '225px', maxWidth: '18%', cursor: 'pointer' }}
            onClick={() => {
              const isSelected = selectedCard === 'processedOrders';
              setSelectedCard(isSelected ? '' : 'processedOrders');
              setTableData(responseData.obj?.['processedOrders']);
            }}
          >
            <Card.Body className="d-flex align-items-center justify-content-between">
              <div>
                <div className="text-muted small">Packed Order</div>
                <div className="h4 mb-0">
                  {responseData?.obj?.processedOrdersCount || 0}
                </div>
              </div>
              <FontAwesomeIcon icon={faTruckFast} className=" h4 mb-0" />
            </Card.Body>
            <p className="text-success px-3 mb-3">Processed Order</p>
          </Card>

          <Card
            className={`flex-grow-1 shadow-sm border-1 cursor-pointer transition-all ${
              selectedCard === 'nextDayOrders' ? 'border-primary shadow-lg' : ''
            }`}
            style={{ minWidth: '225px', maxWidth: '18%', cursor: 'pointer' }}
            onClick={() => {
              const isSelected = selectedCard === 'nextDayOrders';
              setSelectedCard(isSelected ? '' : 'nextDayOrders');
              setTableData(responseData.obj?.['nextDayOrders']);
            }}
          >
            <Card.Body className="d-flex align-items-center justify-content-between">
              <div>
                <div className="text-muted small">Next Day Order</div>
                <div className="h4 mb-0">
                  {responseData?.obj?.nextDayOrdersCount || 0}
                </div>
              </div>
              <FontAwesomeIcon icon={faHourglassStart} className=" h4 mb-0" />
            </Card.Body>
            <p className="text-success px-3 mb-3">
              Process Before 2:30 PM Tomorrow
            </p>
          </Card>

          <Card
            className={`flex-grow-1 shadow-sm border-1 cursor-pointer transition-all ${
              selectedCard === 'delayedOrders' ? 'border-primary shadow-lg' : ''
            }`}
            style={{ minWidth: '225px', maxWidth: '18%', cursor: 'pointer' }}
            onClick={() => {
              const isSelected = selectedCard === 'delayedOrders';
              setSelectedCard(isSelected ? '' : 'delayedOrders');
              setTableData(responseData.obj?.['delayedOrders']);
            }}
          >
            <Card.Body className="d-flex align-items-center justify-content-between">
              <div>
                <div className="text-muted small">Overdue Order</div>
                <div className="h4 mb-0">
                  {responseData?.obj?.delayedOrdersCount || 0}
                </div>
              </div>
              <FontAwesomeIcon icon={faBusinessTime} className=" h4 mb-0" />
            </Card.Body>
            <p className="text-danger px-3 mb-3">Total Delayed Orders</p>
          </Card>
        </div>

        <Card className="border-0 shadow-sm">
          <Card.Body>
            <TableOnly
              id="Analytics Data"
              data={tableData}
              columns={orderTableColumns()}
            />
          </Card.Body>
        </Card>
      </Container>
    </div>
  );
};

export default Order2ShippedReport;

function convertDateToDDMMYYYY(dateString) {
  // Create a Date object from the input string
  const date = new Date(dateString);

  // Get day, month, and year components
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
  const year = date.getFullYear();

  // Format the date as dd/mm/yyyy
  return `${year}-${month}-${day}`;
}
